/*
external je standardna sastavnica koja sadrzia polja koja se dobijaju pri importu i koja se moraju exportovati.

*/


const excel_column_sorted_keys = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "aa",
  "ab",
  "ac",
  "ad",
  "ae",
  "af",
  "ag",
  "ah",
  "ai",
  "aj",
  "ak",
  "al",
  "am",
  "an",
  "ao",
  "ap",
  "aq",
  "ar",
  "as",
  "at",
  "au",
  "av",
  "aw",
  /*
  "ax",
  "ay",
  "az"
  */
];


const _ARCHIVE_sastavnica_excel_sorted_keys = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "aa", "ab", "ac", "ad", "ae", "af", "ag", "ah", "ai", "aj", "ak", "al", "am", "an", "ao", "ap", "aq", "ar", "as"]; // lista keyeva iz definicija sa eksternog api-ja za uvoz excel fajlova


export const sastavnica_excel_sorted_keys = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "aa", "ab", "ac", "ad", "ae", "af", "ag", "ah", "ai", "aj", "ak", "al", "am", "an", "ao", "ap", "aq", "ar", "as", "at", "au", "av", "aw", /*"ax", "ay", "az"*/]; // lista keyeva  za export excel fajlova


export const sastavnica_excel_import_first_row_sorted_values = ["Nivo sastavnice\r\nComponent level", "Kategorija\r\nCategory", "Grupa\r\nGroup", "Ident\r\nItem Code", "Naziv\r\nName", "Tip\r\nType", "Pozicija\r\nPosition", "Kol.\r\nQty", "J.m\r\nUnit", "Operacije\r\nOperation", "Radni centar\r\nWork Center", "Broj izvrasioca\r\nNo. of worker", "Pripremnao vreme\r\nPreparation Time", "Vreme operacije\r\nOperation time", "Stepen slozenosti\r\nlevel of complexity", "Par1", "Par2", "Par3", "Par4", "Par5", "Par6", "Par7", "Par8", "Par9", "Par10", "Par11", "Par12", "Par13", "Par14", "Par15", "Par16", "Par17", "Par18", "Par19", "Par20", "Par21", "Par22", "Par23", "Par24", "Par25", "Par26", "Par27", "Par28", "Par29", "Par30"];


// Eksterne sastavnice pri importu dolaze sa excel keys ali radi lakse identifikacija kolona mi koristimo ove external_keys
// Ovo su keys koje dodeljujemo eksternim sastavnicama za lakšu identifikaciju kolona pri importu a pri eksportu ovaj spisak koristimo da bi filtrirali samo one kolone koje idu u eksportnu sastavnicu.
export const sastavnica_external_sorted_keys = ["Nivo", "Kat", "Grupa", "Ident", "Naziv", "Tip", "Pozicija", "Kolicina", "JM", "Operacija", "Radni_centar", "Broj_izvrsioca", "Vreme_pripreme", "Vreme_operacije", "Stepen_slozenosti", "Par1", "Par2", "Par3", "Par4", "Par5", "Par6", "Par7", "Par8", "Par9", "Par10", "Par11", "Par12", "Par13", "Par14", "Par15", "Par16", "Par17", "Par18", "Par19", "Par20", "Par21", "Par22", "Par23", "Par24", "Par25", "Par26", "Par27", "Par28", "Par29", "Par30", "Par_jezik", "Materijal", "Digest", "Ident_prefix"];


// Ovo su keys za internu sastavnicu koja sadrzi i neke kolone koje nisu postojale na importu i koje ne idu u eksport. Ovo je neka vrsta prosirenja external keys
export const sastavnica_internal_sorted_keys = ["Nivo", "Nivo_importovani", "Kat", "Grupa", "virtelclass", "Ident", "Calculated_ident", /*"Genus_ident",*/ "Custom_ident", "acIdent", "acIdentChild", "workOrder", "infoID", "Naziv", "Tip", "Pozicija", "Kolicina_za_nalog", "Kolicina", "JM", "Masa_po_jm", "Masa_kumulativno", "Operacija", "Radni_centar", "Broj_izvrsioca", "Vreme_pripreme", "Vreme_operacije", "Vreme_ugradnje", "Vreme_op_sklapanje", "Stepen_slozenosti", "Vreme_kumulativno", "Cena_po_jm", "Cena_kumulativno", "Par1", "Par2", "Par3", "Par4", "Par5", "Par6", "Par7", "Par8", "Par9", "Par10", "Par11", "Par12", "Par13", "Par14", "Par15", "Par16", "Par17", "Par18", "Par19", "Par20", "Par21", "Par22", "Par23", "Par24", "Par25", "Par26", "Par27", "Par28", "Par29", "Par30", "Par_jezik", "Materijal", "Digest", "Ident_prefix", "CNC_crtez", "CNC_program1", "CNC_program2", "_CNC_tip", "_ident_nadredjenog", "_ident_modula", "_modulprofil_kolikozaobradu", "_debug", "authorBomRevId"];


// 
export const sastavnica_internal_Par1Par30_keys = ["Par1", "Par2", "Par3", "Par4", "Par5", "Par6", "Par7", "Par8", "Par9", "Par10", "Par11", "Par12", "Par13", "Par14", "Par15", "Par16", "Par17", "Par18", "Par19", "Par20", "Par21", "Par22", "Par23", "Par24", "Par25", "Par26", "Par27", "Par28", "Par29", "Par30"];


// NOVO 2023
export const sastavnica_internal_key_to_excel_key_translations = {
  "Nivo": "a",
  "Kat": "b",
  "Grupa": "c",
  "virtelclass": false,
  "Ident": "d",
  "Calculated_ident": false,
  "Genus_ident": false,
  "Custom_ident": false,
  "acIdent": false,
  "acIdentChild": false,
  "workOrder": false,
  "infoID": false,
  "Naziv": "e",
  "Tip": "f",
  "Pozicija": "g",
  "Kolicina_za_nalog": false,
  "Kolicina": "h",
  "JM": "i",
  "Operacija": "j",
  "Radni_centar": "k",
  "Broj_izvrsioca": "l",
  "Vreme_pripreme": "m",
  "Vreme_operacije": "n",
  "Vreme_ugradnje": false,
  "Vreme_op_sklapanje": false,
  "Stepen_slozenosti": "o",
  "Vreme_kumulativno": false,
  "Par1": "p",
  "Par2": "q",
  "Par3": "r",
  "Par4": "s",
  "Par5": "t",
  "Par6": "u",
  "Par7": "v",
  "Par8": "w",
  "Par9": "x",
  "Par10": "y",
  "Par11": "z",
  "Par12": "aa",
  "Par13": "ab",
  "Par14": "ac",
  "Par15": "ad",
  "Par16": "ae",
  "Par17": "af",
  "Par18": "ag",
  "Par19": "ah",
  "Par20": "ai",
  "Par21": "aj",
  "Par22": "ak",
  "Par23": "al",
  "Par24": "am",
  "Par25": "an",
  "Par26": "ao",
  "Par27": "ap",
  "Par28": "aq",
  "Par29": "ar",
  "Par30": "as",
  "Par_jezik": "at",
  "Materijal": "au",
  "Digest": "av",
  "Ident_prefix": "aw",
  "CNC_crtez": false,
  "CNC_program1": false,
  "CNC_program2": false,
  "_CNC_tip": false,
  "_ident_modula": false,
  "_ident_nadredjenog": false,
  "authorBomRevId": false,
  "_modulprofil_kolikozaobradu": false,
  "_debug": false
};


// NOVO 2023
export const sastavnica_excel_key_to_internal_key_translations = {
  "a": "Nivo",
  "b": "Kat",
  "c": "Grupa",
  // "virtelclass": false,
  "d": "Ident",
  // "Calculated_ident": false,
  // "Genus_ident": false,
  // "Custom_ident": false,
  "e": "Naziv",
  "f": "Tip",
  "g": "Pozicija",
  // "Kolicina_za_nalog": false,
  "h": "Kolicina",
  "i": "JM",
  "j": "Operacija",
  "k": "Radni_centar",
  "l": "Broj_izvrsioca",
  "m": "Vreme_pripreme",
  "n": "Vreme_operacije",
  // "Vreme_ugradnje": false,
  // "Vreme_op_sklapanje": false,
  "o": "Stepen_slozenosti",
  // "Vreme_kumulativno": false,
  "p": "Par1",
  "q": "Par2",
  "r": "Par3",
  "s": "Par4",
  "t": "Par5",
  "u": "Par6",
  "v": "Par7",
  "w": "Par8",
  "x": "Par9",
  "y": "Par10",
  "z": "Par11",
  "aa": "Par12",
  "ab": "Par13",
  "ac": "Par14",
  "ad": "Par15",
  "ae": "Par16",
  "af": "Par17",
  "ag": "Par18",
  "ah": "Par19",
  "ai": "Par20",
  "aj": "Par21",
  "ak": "Par22",
  "al": "Par23",
  "am": "Par24",
  "an": "Par25",
  "ao": "Par26",
  "ap": "Par27",
  "aq": "Par28",
  "ar": "Par29",
  "as": "Par30",
  "at": "Par_jezik",
  "au": "Materijal",
  "av": "Digest",
  "aw": "Ident_prefix",
  /*
  "ax": null,
  "ay": null,
  "az": null,
  */
  // "Materijal": false,
  // "CNC_crtez": false,
  // "CNC_program1": false,
  // "CNC_program2": false,
  // "_CNC_tip": false,
};



// definicija sa externog api-ja
export const sastavnica_external_columns_full = {
  // "id": '?',
  "a": "Nivo sastavnice\nComponent level",
  "b": "Kategorija\nCategory",
  "c": "Grupa\nGroup",
  "d": "Ident\nItem Code",
  "e": "Naziv\nName",
  "f": "Tip\nType",
  "g": "Pozicija\nPosition",
  "h": "Kol.\nQty",
  "i": "J.m\nUnit",
  "j": "Operacije\nOperation",
  "k": "Radni centar\nWork Center",
  "l": "Broj izvrsioca\nNo. of worker",
  "m": "Pripremno vreme\nPreparation Time",
  "n": "Vreme operacije\nOperation time",
  "o": "Stepen slozenosti\nLevel of complexity",
  "p": "Par1",
  "q": "Par2",
  "r": "Par3",
  "s": "Par4",
  "t": "Par5",
  "u": "Par6",
  "v": "Par7",
  "w": "Par8",
  "x": "Par9",
  "y": "Par10",
  "z": "Par11",
  "aa": "Par12",
  "ab": "Par13",
  "ac": "Par14",
  "ad": "Par15",
  "ae": "Par16",
  "af": "Par17",
  "ag": "Par18",
  "ah": "Par19",
  "ai": "Par20",
  "aj": "Par21",
  "ak": "Par22",
  "al": "Par23",
  "am": "Par24",
  "an": "Par25",
  "ao": "Par26",
  "ap": "Par27",
  "aq": "Par28",
  "ar": "Par29",
  "as": "Par30",
  "at": "Par_jezik",
  "au": "Materijal",
  "av": "Digest",
  "aw": "Ident_prefix",
  /*
  "ax": null,
  "ay": null,
  "az": null
  */
};



export const sastavnica_csv_keys_sr = 'Nivo,Kat.,Grupa,Ident,Naziv,Tip,Pozicija,Kol.,j.m.,Operacija,Radni centar,Broj izvrsioca, Pripremno vreme,Vreme operacije,Stepen slozenosti,Par1,Par2,Par3,Par4,Par5,Par6,Par7,Par8,Par9,Par10,Par11,Par12,Par13,Par14,Par15,Par16,Par17,Par18,Par19,Par20,Par21,Par22,Par23,Par24,Par25,Par26,Par27,Par28,Par29,Par30';



// Ovo je bilo samo eksperimentisanje radi predloga naziva polja u bazi. Moze se obrisati.
const sastavnica_external_columns_temp_v2_experimental = {
  "a": "nivo",
  "b": "kategorija",
  "c": "grupa",
  "d": "ident",
  "e": "naziv",
  "f": "tip",
  "g": "pozicija",
  "h": "kolicina",
  "i": "jm",
  "j": "operacija",
  "k": "radni_centar",
  "l": "broj_izvrsilaca",
  "m": "vreme_pripreme",
  "n": "vreme_operacije",
  "o": "vreme_ugradnje",
  "p": "vreme_kumulativno",
  "r": "par1",
  "s": "par2",
  "t": "par3"
};